// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orders-page-wrapper {
  cursor: auto;
}
.orders-page-wrapper .orders-page-title .vert-title {
  margin-top: var(--spacing-small);
  margin-bottom: var(--spacing-big);
  cursor: auto;
}
.orders-page-wrapper .orders-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--spacing-big);
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/pages/orders/OrdersStyles.less"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AAFA;EAKY,gCAAA;EACA,iCAAA;EACA,YAAA;AAAZ;AAPA;EAYQ,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;AAFR","sourcesContent":[".orders-page-wrapper {\n    cursor: auto;\n\n    .orders-page-title {\n        .vert-title {\n            margin-top: var(--spacing-small);\n            margin-bottom: var(--spacing-big);\n            cursor: auto;\n        }\n    }\n\n    .orders-pagination {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-bottom: var(--spacing-big);\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
